export const ipfsToAnimaMirror = (ipfsURL: string): URL => {
    if (ipfsURL.startsWith('ipfs')) {
        const path = ipfsURL.slice(7);
        return new URL(`https://ipfs-mirror.anima.supply/${path}`);
    }
    console.warn("URL passed to ipfsToAnimaMirror didn't start with 'ipfs'");
    return new URL(ipfsURL);
};

interface Asset {
    name: string;
    type: string;
    uri: string;
}
const getAssetUri =
    (key: string) =>
    (assets: Asset[]): string => {
        const asset = assets.find(({ name }: { name: string }) => name === key);
        if (asset) {
            return ipfsToAnimaMirror(asset.uri).href;
        }
        console.error(`No asset found, looking for key: '${key}'`);
        return '';
    };

export const getQrTextureUri = getAssetUri('qr-texture');
export const getGltfUri = getAssetUri('gltf');
